import type { Router } from 'vue-router';
import { useCognitoAuthManager } from '@/shared/access/useCognitoAuthManager';
import { Pages } from '@/pages/pages';
import CognitoAuth from './CognitoAuth';

const noAuthRequiredPaths = [
    Pages.Login,
    Pages.HostedLogin,
    Pages.LoginCallback,
    Pages.ResetPassword,
] as string[];

export function setupAuthGuard(router: Router) {
    router.beforeEach(async (to, from, next) => {
        // Skip auth check for login pages
        if( noAuthRequiredPaths.includes(to.path)) {
            next();
            return;
        }

        try {

            // Cognito authentication flow
            const { AuthManager, initializeAsync } = useCognitoAuthManager();

            // Initialize Cognito auth if not already done
            await initializeAsync();

            if (!AuthManager.value.isAuthenticated) {
                CognitoAuth.setOriginalUri(to.fullPath);
                next(Pages.Login);
                return;
            }
            next();
        } catch (error) {
            console.error('Authentication guard error:', error);
            // On error, redirect to login page
            next(Pages.Login);
        }
    });
}